import React from 'react';
import { ParentNodeProvider } from '../../providers/ParentNodeProvider';
import { TextContent } from '../TextContent/TextContent';
import { ICustomButton, CustomButton } from '../CustomButton/CustomButton';
import './SingleColCustomTextBtns.scss';

export const SingleColCustomTextBtns = ({ node }) => {
    const customLinks: ICustomButton[] =
        node.relationships?.field_custom_button;
    const sectionTheme = node.field_theme?.toLowerCase();
    return (
        <ParentNodeProvider
            nodeName={node.relationships?.field_copy?.heading}
            nodeType="Single_Col_Custom_Btns"
        >
            <section
                className={`themed-container c--single-col-custom-text-btns ${
                    sectionTheme === `white` ? `light` : sectionTheme
                } ${node.field_lc_align?.toLowerCase()} ${
                    node.field_stackable ? `stackable` : ``
                }`}
            >
                {node.relationships?.field_copy && (
                    <TextContent
                        className="kite-container"
                        node={node.relationships?.field_copy}
                        headingOption={node.field_heading_option}
                    />
                )}
                {customLinks && customLinks[0]?.field_custom_button_link && (
                    <div className="kite-container buttons">
                        {customLinks.map((link, idx) => (
                            <CustomButton key={idx} {...link} />
                        ))}
                    </div>
                )}
            </section>
        </ParentNodeProvider>
    );
};
